import { HostViewProperties, ViewProperties, ViewType } from '@fluidx/office-fluid-types';
import { assertNever } from 'owa-assert';
import { FluidOwaSource } from 'owa-fluid-validations';

export class OWAHostViewProperties implements HostViewProperties {
    readonly source: FluidOwaSource;

    constructor(source: FluidOwaSource) {
        this.source = source;
    }

    public get HostViewProperties() {
        return this;
    }

    public getViewProperties() {
        return getViewPropertiesInternal(this.source);
    }
}

function getViewPropertiesInternal(source: FluidOwaSource): Promise<ViewProperties> {
    return new Promise(resolve => resolve({ viewType: getViewTypeFromSource(source) }));
}

function getViewTypeFromSource(source: FluidOwaSource): ViewType {
    switch (source) {
        case FluidOwaSource.CalendarReadingPane:
        case FluidOwaSource.CalendarCompose:
        case FluidOwaSource.MailCalendarCard:
            return ViewType.Medium;
        case FluidOwaSource.MailCompose:
        case FluidOwaSource.MailReadingPane:
        case FluidOwaSource.AgendaEditor:
        case FluidOwaSource.Timestream:
        case FluidOwaSource.None:
            return ViewType.Large;
        default:
            return assertNever(source);
    }
}
